import { iValidate } from './types'

export interface iStore {
  access_token: string
  validateRequest: iValidate
}
const store = {} as iStore

export type iPut = <T extends keyof iStore>(
  key: T,
  value: iStore[T],
) => iStore[T]
const put: iPut = (key, value) => {
  store[key] = value
  return value
}

export type iGet = <T extends keyof iStore>(key: T) => iStore[T]
const get: iGet = (key) => store[key]

export { get, put }
